// ノード補完プラグインが返す `replace`（入力した参照を正規化した形）を本文に反映する。
// 例: `またい７：７ーーー` → `マタイ 7:7---`。置き換え情報が無い・一致しないときは入力のまま返す。
export type PluginReplace = { from?: unknown; to?: unknown } | null | undefined;

export function applyPluginReplace(body: string, trigger: string, replace: PluginReplace): string {
  const from = replace && typeof replace.from === 'string' ? replace.from : '';
  const to = replace && typeof replace.to === 'string' ? replace.to : '';
  if (from === '' || to === '' || !body.endsWith(from)) {
    return body + trigger;
  }
  // 全角の長音 3 つは、半角の `---` にそろえる。
  const normalizedTrigger = trigger === 'ーーー' ? '---' : trigger;
  return body.slice(0, body.length - from.length) + to + normalizedTrigger;
}
